import axios from "axios";
import config from "../../src/config/app.json";

export function apiRequest(method, url, params) {
  try {
    if (method === "get") {
      return axios
        .get(url)
        .then(function (response) {
          if (response.status !== 302) {
            return response;
          } else {
            window.location.href =
              config["APIURIS"][config["APIURIS"]["current"]];
          }
        })
        .catch(function (error) {
          return { error: true, data: error };
        });
    } else if (method === "post") {
      return axios({
        method: method,
        mode: "cors",
        url: url,
        data: params,
      })
        .then((response) => {
          if (response.status !== 302) {
            return response;
          } else {
            window.location.href =
              config["APIURIS"][config["APIURIS"]["current"]];
          }
        })
        .catch((error) => {
          return { error: true, data: error };
        });
    }
  } catch (error) {
    return { error: true, data: error };
  }
}
